import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Marigold } from "../components/Marigold";
import { LoteriaCard } from "../components/LoteriaCard";
import { CardOnlyBanner } from "../components/CardOnlyBanner";
import { BRAND_WORDMARK, BRAND_TAGLINE } from "../lib/brand";

export default function Attract() {
  const [welcome, setWelcome] = useState("una lotería de sabores");
  useEffect(() => {
    fetch("/api/settings/public").then((r) => r.json()).then((s: any) => {
      if (s?.kiosk_welcome_line) setWelcome(s.kiosk_welcome_line);
    }).catch(() => {});
  }, []);
  return (
    <Link
      to="/kiosk/language"
      className="grain relative flex flex-col min-h-screen w-full bg-ink text-paper overflow-hidden"
    >
      {/* big diagonal type, edge-to-edge */}
      <div className="flex-1 relative flex items-center justify-center px-6">
        {/* corner ornaments */}
        <span className="absolute top-6 left-6 font-mono text-xs tracking-widest text-paper/60">EST · MX · MTY</span>
        <span className="absolute top-6 right-6 font-mono text-xs tracking-widest text-paper/60">№ 001</span>
        <span className="absolute bottom-6 left-6 font-hand text-xl text-mango">el bar to-go</span>
        <span className="absolute bottom-6 right-6 font-mono text-xs tracking-widest text-paper/60">{new Date().getFullYear()}</span>

        <div className="text-center">
          <div className="font-mono text-xs tracking-[0.5em] text-mango uppercase mb-4 animate-rise" style={{ animationDelay: "120ms" }}>{BRAND_TAGLINE}</div>
          <h1 className="font-display font-black text-[14rem] leading-[0.85] tracking-kerned animate-rise">
            <span className="block">{BRAND_WORDMARK}</span>
          </h1>
          <div className="flex items-center justify-center gap-4 mt-6 animate-rise" style={{ animationDelay: "240ms" }}>
            <span className="h-px w-20 bg-paper/40" />
            <span className="font-display italic text-2xl text-mango pb-1 leading-[1.1]">{welcome}</span>
            <span className="h-px w-20 bg-paper/40" />
          </div>
        </div>

        {/* Floating loteria card in the corner — the memorable hot spot */}
        <div className="absolute -bottom-6 right-12 hidden md:block">
          <div className="origin-bottom-right rotate-[8deg] animate-breathe">
            <div className="scale-90 animate-slowFlip" style={{ perspective: "800px" }}>
              <LoteriaCard
                rotate={0}
                number={0}
                emblem="🍹"
                title="La Margarita"
                caption="con sal de Colima"
                className="w-56"
              />
            </div>
          </div>
        </div>

        {/* Marigold accent */}
        <div className="absolute -left-6 top-1/3">
          <div className="opacity-30"><Marigold size={120} /></div>
        </div>
      </div>

      {/* Card-only banner — predominant, above CTA */}
      <div className="flex justify-center mb-6">
        <CardOnlyBanner variant="dark" size="lg" />
      </div>

      {/* CTA — pulsing "tap" button */}
      <div className="pb-14 flex justify-center">
        <div className="relative">
          <div className="absolute inset-0 rounded-full border-2 border-mango/40 animate-ping" />
          <div className="relative px-12 py-5 rounded-full bg-mezcal text-paper font-display text-2xl font-bold tracking-wide shadow-[0_8px_30px_-8px_rgba(200,75,26,0.7)]">
            Toca para ordenar · Tap to order
          </div>
        </div>
      </div>
    </Link>
  );
}
